<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container md center">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <span class="hdg02">並び順の設定</span>
        </div>
        <div class="popup-content">
          <form @submit.prevent>
            <div class="formparts radio">
              <input type="radio" value="date_new" id="note_search_order_setting_01" v-model="state.search">
              <label role="button" for="note_search_order_setting_01">更新日（新しい順）</label>
            </div>
            <div class="formparts radio">
              <input type="radio" value="date_old" id="note_search_order_setting_02" v-model="state.search">
              <label role="button" for="note_search_order_setting_02">更新日（古い順）</label>
            </div>
            <div class="formparts radio">
              <input type="radio" value="name" id="note_search_order_setting_03" v-model="state.search">
              <label role="button" for="note_search_order_setting_03">タイトル順（50音順）</label>
            </div>
            <div class="button mt32">
              <button class="btn" @click="submit">設定</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'

export default defineComponent({
  name: 'PCNoteSearchOrderSetting',
  setup (props, context) {
    const store = context.root.$store
    const { note } = store.state

    const state = reactive({
      search: 'date_new'
    })
    // 初期値
    state.search = store.getters['note/search']

    const close = () => {
      context.emit('close')
    }
    const submit = () => {
      store.dispatch('note/setOrder', state.search)
      context.emit('close')
    }

    return {
      state,
      close,
      submit
    }
  }
})
</script>

<style lang="scss" scoped>
  .popup-content .button {
    width: 267px;
    margin-right: auto;
    margin-left: auto;
  }
</style>
